import type { Theme } from "@mui/material";
import { createTheme as createMuiTheme } from "@mui/material/styles";

import { themeOptions } from "./theme-options";

type Color = {
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
};

declare module "@mui/material/styles" {
  interface Palette {
    colors?: {
      primary: Color;
      grey: Color;
      success: Color;
      error: Color;
    };
  }
  interface PaletteOptions {
    colors?: {
      primary: Color;
      grey: Color;
      success: Color;
      error: Color;
    };
  }
}

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    dashed: true;
    glass: true
  }
}

declare module "@mui/material/Card" {
  interface CardPropsVariantOverrides {
    glass: true;
    dashed: true;
  }
}

declare module "@mui/material/Divider" {
  interface DividerPropsVariantOverrides {
    gradient: true;
  }
}

export const createTheme = (): Theme => {
  return createMuiTheme(themeOptions);
};
